<template>
  <div class="">
    <Wait_Skeleton v-if="!IsWait" />

    <Card class="" v-if="IsWait">
      <template #title>
        <div class="pl-5 pr-5" style="display: flex; justify-content: space-between; align-items: center;">
          <span class="font-bold text-lg">Müşteri Düzenle</span>
          <Tag :value="PasifMi ? 'Pasif' : 'Aktif'" :severity="PasifMi ? 'danger' : 'success'"  class="text-base px-3 py-1 rounded-md" />
        </div>
      </template>
      <template #content>
        <div class="grid">
          <fieldset :disabled="PasifMi" style="border: none; padding: 0; margin: 0;">
            <div class="col-12">
              <Tabs value="0">
                <TabList>
                  <Tab value="0">Genel Bilgiler</Tab>
                  <Tab value="1">İletişim Bilgileri</Tab>
                  <Tab value="2">Geçmiş İşlemler</Tab>
                  <Tab value="3">Boş</Tab>
                </TabList>
                <TabPanels>
                  <!-- GENEL BİLGİLER -->
                  <TabPanel value="0">
                    <div class="formgrid grid ">
                      <div class="field col md:col-4">
                        <label for="Isim" class="font-bold block">İsim</label>
                        <InputText id="Isim" type="text" v-model="Isim" class="text-base text-color w-full"
                          :invalid="this.Valid.Isim" />
                      </div>
                      <div class="field col md:col-4"></div>
                      <div class="field col md:col-4">
                        <label for="Grup" class="font-bold block">Grup</label>
                        <Select id="Grup" v-model="pGrup" :options="GrupListesi" optionLabel="Ad"
                          optionValue="Grup_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                          :invalid="this.Valid.pGrup" class="text-base text-color w-full" />
                      </div>
                      <div class="field col md:col-4">
                        <label for="CepTelefon" class="font-bold block">Cep Telefon</label>
                        <InputMask id="CepTelefon" v-model="CepTelefon" mask="(999) 999-9999"
                          placeholder="(999) 999-9999" :invalid="this.Valid.CepTelefon" fluid />
                      </div>
                      <div class="field col md:col-4">
                        <label for="EPosta" class="font-bold block">E-Posta</label>
                        <InputText id="EPosta" type="text" v-model="EPosta" class="text-base text-color w-full"
                          :invalid="this.Valid.EPosta" />
                      </div>
                      <div class="field col md:col-4">
                        <label for="WebAdres" class="font-bold block">Web Adres</label>
                        <InputText id="WebAdres" type="text" v-model="WebAdres" class="text-base text-color w-full"
                          :invalid="this.Valid.WebAdres" />
                      </div>
                      <div class="field col md:col-6">
                        <label for="Aciklama" class="font-bold block">Açıklama</label>
                        <Textarea id="Aciklama" v-model="Aciklama" rows="2" cols="30" :invalid="this.Valid.Aciklama"
                          class="text-base text-color w-full" />
                      </div>
                      <div class="field col md:col-6">
                        <label for="IletisimAdres" class="font-bold block">Adres</label>
                        <Textarea id="IletisimAdres" v-model="IletisimAdres" rows="2" cols="30"
                          :invalid="this.Valid.IletisimAdres" class="text-base text-color w-full" />

                      </div>
                    </div>
                  </TabPanel>
                  <!-- İLETİŞİM BİLGİLERİ -->
                  <TabPanel value="1">


                  </TabPanel>
                  <TabPanel value="2">
                    <MusteriGecmisIslemler :pMusteri="this.Musteri_rowid" />
                  </TabPanel>
                  <!-- BOŞ -->
                  <TabPanel value="3">

                  </TabPanel>
                </TabPanels>
              </Tabs>
            </div>
          </fieldset>
          <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
          </div>
          <div class="col-6 flex justify-content-start flex-wrap">
            <Button class="m-1" label="Aktif Et" icon="pi pi-refresh" iconPos="right" size="small" severity="warn"
              @click="this.AktifEt()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor && PasifMi" />
            <Button class="m-1" label="Pasif Et" icon="pi pi-refresh" iconPos="right" size="small" severity="warn"
              @click="this.PasifEt()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor && !PasifMi" />
          </div>
          <div class="col-6 flex justify-content-end flex-wrap">
            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
              @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor && !PasifMi" />

          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";
import MusteriGecmisIslemler from "./MusteriGecmisIslemler.vue"

export default {
  data() {
    return {
      IslemYapiliyor: false,
      IsWait: false,
      Musteri_rowid: 0,
      PasifMi: true,
      //
      GrupListesi: [],

      // Genel Bilgiler
      pGrup: "",
      Aciklama: "",
      // İletişim Bilgileri
      Isim: "",
      IletisimAdres: "",
      CepTelefon: "",
      EPosta: "",
      WebAdres: "",

      //--------------
      // Validation Elements
      Valid: {
        pGrup: false,
        Aciklama: false,
        Isim: false,
        IletisimAdres: false,
        CepTelefon: false,
        EPosta: false,
        WebAdres: false,
      }
    };
  },
  methods: {
    AktifEt() {
      this.IslemYapiliyor = true;

      let data = {
        pMusteri: this.Musteri_rowid,
      };
      GlobalServis.GlobalServis("POST", "UpdateMusteriAktif", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Müşteri aktif duruma getirilmiştir.",
            life: 3000,
          });

        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Musteri/MusteriListesi" });
      });
    },
    PasifEt() {
      this.IslemYapiliyor = true;

      let data = {
        pMusteri: this.Musteri_rowid,
      };
      GlobalServis.GlobalServis("POST", "DeleteMusteri", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Müşteri pasif duruma getirilmiştir.",
            life: 3000,
          });
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Musteri/MusteriListesi" });
      });
    },
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;

      let data = {
        Musteri_rowid: this.Musteri_rowid,
        pGrup: this.pGrup,
        Aciklama: this.Aciklama,
        Isim: this.Isim,
        IletisimAdres: this.IletisimAdres,
        CepTelefon: this.CepTelefon,
        EPosta: this.EPosta,
        WebAdres: this.WebAdres,
      };
      GlobalServis.GlobalServis("POST", "UpdateMusteri", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Musteri düzenlenmiştir.",
            life: 3000,
          });
          this._ResetForm();
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Musteri/MusteriListesi" });
      });
    },
    _MusteriInfo() {
      this.Musteri_rowid = this.$route.query.MusteriNo;
      let data = {
        Musteri_rowid: this.$route.query.MusteriNo,
      };

      GlobalServis.GlobalServis("POST", "GetMusteriInfo", data).then((res) => {
        if (res.status === 200) {
          this.pGrup = res.data[0].pGrup;
          this.Aciklama = res.data[0].Aciklama;
          this.Isim = res.data[0].Isim;
          this.IletisimAdres = res.data[0].IletisimAdres;
          this.CepTelefon = res.data[0].CepTelefon;
          this.EPosta = res.data[0].EPosta;
          this.WebAdres = res.data[0].WebAdres;
          this.PasifMi = res.data[0].PasifMi;

          this.IsWait = true;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });

    },
    _GrupListesi() {
      GlobalServis.GlobalServis("GET", "GetGrup_Musteri", "").then((res) => {
        if (res.status == 200) {
          this.GrupListesi = res.data;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });

    },
    _ResetForm() {
      this.pGrup = 0;
      this.Aciklama = "";
      this.Isim = "";
      this.IletisimAdres = "";
      this.CepTelefon = "";
      this.EPosta = "";
      this.WebAdres = "";
    },
    _FormCheck() {
      let Check = false;

      if (this.pGrup === 0) {
        this.Valid.pGrup = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Grup seçin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.pGrup = false; Check = false; }

      if (this.Isim === "") {
        this.Valid.Isim = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "İsim girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Isim = false; Check = false; }

      if (this.IletisimAdres === "") {
        this.Valid.IletisimAdres = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "İletişim adresi girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.IletisimAdres = false; Check = false; }

      if (this.CepTelefon === "") {
        this.Valid.CepTelefon = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Cep telefonu girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.CepTelefon = false; Check = false; }

      if (this.EPosta === "") {
        this.Valid.EPosta = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "E-Posta adresi girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.EPosta = false; Check = false; }

      return Check;
    },
  },
  created() {
    this._MusteriInfo();
    this._GrupListesi();
  },
  components: {
    MusteriGecmisIslemler
  },
};
</script>